// constants
export const DATASETS_BASE_PATH = 'datasets';

// endpoints
export const RELEASES_BASE_PATH = 'releases';

export const PROJECT_BASE_PATH = 'projects';
export const PROJECT_DATASET_RELEASES_BASE_PATH = 'dataset-releases';
